import { UnexpectedError } from 'utils/errors';
import { customFetch } from 'utils/http';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  idUser: number;
  newPassword: string;
};

export const setUserPassword = async (params: Params) => {
  const { idUser, newPassword } = params;

  const body = new FormData();

  body.append('idUser', `${idUser}`);
  body.append('newPassword', newPassword);

  const response = await customFetch(getM8AdminURL('setUserPassword'), {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
